import { render, staticRenderFns } from "./ChangedBox.vue?vue&type=template&id=4ea3c246&scoped=true&"
import script from "./ChangedBox.vue?vue&type=script&lang=js&"
export * from "./ChangedBox.vue?vue&type=script&lang=js&"
import style0 from "./ChangedBox.vue?vue&type=style&index=0&id=4ea3c246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3c246",
  null
  
)

export default component.exports